import React, { useEffect, useState } from "react";
import { CMS_url } from "urlconfig";
import { CMS_maati } from "urlconfig";

export const TabLevelData = ({ apiUrl, selectedFarmer }) => {
  const economic = selectedFarmer?.farmer_economic;
  const environmental = selectedFarmer?.farmer_environmental;
  const social = selectedFarmer?.farmer_social;

  const [labels, setLabels] = useState([]);

  let data = null;
  if (apiUrl === "farmer-level-economics") {
    data = economic;
  } else if (apiUrl === "farmer-level-environmentals") {
    data = environmental;
  } else if (apiUrl === "farmer-level-socials") {
    data = social;
  }
  const paramMap = {
    "farmer-level-economics": "farmer_economic",
    "farmer-level-environmentals": "farmer_environmental",
    "farmer-level-socials": "farmer_social",
  };

  const Params = paramMap[apiUrl] || "";

  useEffect(() => {
    async function fetchLabels() {
      try {
        const res = await fetch(
          `${CMS_maati}/api/ui-schemas?filters[form_name]=${Params}&filters[language]=en`
        );
        const data = await res.json();
        setLabels(data?.data[0]?.labels?.form_data?.components);
      } catch (err) {
        console.error("API fetch error:", err);
      }
    }

    fetchLabels();
  }, [apiUrl]);

  const formatKey = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const getLabelForKey = (key) => {
    const found = labels?.find((item) => item.key === key);
    return found?.label || formatKey(key);
  };

  if (!data) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5 text-muted">
        <p className="mb-0">No data available</p>
      </div>
    );
  }

  return (
    <div className=" my-3">
      <div className="row g-3">
        {Object.entries(data).map(([key, value]) => {
          if (
            key === "id" ||
            key === "documentId" ||
            key === "createdAt" ||
            key === "updatedAt" ||
            key === "publishedAt" ||
            key === "farmer_id"
          )
            return null;

          // if (
          //   value === "" ||
          //   value === null ||
          //   (Array.isArray(value) && value.length === 0)
          // )
          //   return null;

          let displayValue = "";
          if (Array.isArray(value)) {
            displayValue = value.join(", ");
          } else if (typeof value === "object" && value !== null) {
            displayValue = JSON.stringify(value);
          } else {
            displayValue = value?.toString() || "-";
          }

          return (
            <div className="col-md-6 col-lg-4" key={key}>
              <div className="border rounded-3 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-start ">
                  <i className="mdi mdi-chevron-double-right text-success me-2 fs-5"></i>
                  <span className="fw-semibold text-dark mt-1">
                    {getLabelForKey(key)}
                  </span>
                </div>

                <div className="d-flex align-items-center">
                  <i className="mdi mdi-chevron-right me-2 fs-5"></i>
                  <span className="text-gray">{displayValue}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
